module.exports = __webpack_public_path__ + "media/images/tokyo-2f5ae58049d8e4001b12ba7337580309.png";